import React, { useContext, useEffect, useState } from 'react'
import Renderif from '../../components/renderif'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'
import { AlertContext } from '../../context/alert_context'
import Loader from '../../components/loader'
import { primary } from '../../utils/colors'
import { useNavigate } from 'react-router-dom'
import { IoClose } from 'react-icons/io5'
import { BiTrash } from 'react-icons/bi'
import { MdAdd } from 'react-icons/md'


export default function DatesOfLaborEspecialist({ ...props }, { onClose = () => { } }) {
    let _slots = [
        {
            "dayOfWeek": "Thursday",
            "timeRanges": [
                {
                    "endTime": "18:00:00",
                    "startTime": "14:00:00",
                },
                {
                    "endTime": "12:00:00",
                    "startTime": "08:00:00",
                }
            ]
        },
        {
            "dayOfWeek": "Sunday",
            "timeRanges": [
                {
                    "endTime": "18:00:00",
                    "startTime": "14:00:00",
                },
                {
                    "endTime": "12:00:00",
                    "startTime": "08:00:00",
                }
            ]
        },
        {
            "dayOfWeek": "Tuesday",
            "timeRanges": [
                {
                    "endTime": "18:00:00",
                    "startTime": "14:00:00",
                },
                {
                    "endTime": "12:00:00",
                    "startTime": "08:00:00",
                }
            ]
        },
    ];
    const navigate = useNavigate();


    const { user } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    const [state, setState] = useState({

        loading: false,
        rol_active: null,
        specialist: null,
        slots:_slots,

    })
    const [] = useState([])

    function assignDay(day) {
    }
    
    const loadSpecialist = async () => {
        // setState({ ...state, loading: true })
        setState({ ...state, slots: _slots })
        console.log(state.slots)
        for (let i = 0; i < state.slots.length; i++) {
            // OBTENGO LOS DÍAS ACTIVOS Y PALOMEO LOS CHECKBOX
            console.log(state.slots[i].dayOfWeek)
            document.getElementById(state.slots[i].dayOfWeek).checked = true;
            // MUESTRO LOS DIVS DEL DIA DE LA SEMANA VISIBLES
            document.getElementById(state.slots[i].dayOfWeek + "_div").classList.remove("d-none");

            // RECORRE LOS HORARIOS EN ASIGNADOS AL COACH
            for (let j = 0; j < state.slots[i].timeRanges.length; j++) {
                if (j === (state.slots[i].timeRanges.length - 1)) {
                    let targetDiv = document.getElementById(state.slots[i].dayOfWeek + "_div").getElementsByClassName("select-container");
                    for (let x = 0; x < targetDiv[targetDiv.length - 1].getElementsByClassName("interaction-button").length; x++) {
                        targetDiv[targetDiv.length - 1].getElementsByClassName("interaction-button")[x].classList.remove("d-none");
                    }
                }
            }
        }
        // console.log(state.slots)
        // setState({ ...state, specialist: _specialists.data,loading: false })
    }

    const displayHours = () => {
        // setState({ ...state, loading: true })

        for (let i = 0; i < state.slots.length; i++) {
            // OBTENGO LOS DÍAS ACTIVOS Y PALOMEO LOS CHECKBOX
            document.getElementById(state.slots[i].dayOfWeek).checked = true;
            // MUESTRO LOS DIVS DEL DIA DE LA SEMANA VISIBLES
            document.getElementById(state.slots[i].dayOfWeek + "_div").classList.remove("d-none");

            // RECORRE LOS HORARIOS EN ASIGNADOS AL COACH
            for (let j = 0; j < state.slots[i].timeRanges.length; j++) {
                if (j === (state.slots[i].timeRanges.length - 1)) {
                    let targetDiv = document.getElementById(state.slots[i].dayOfWeek + "_div").getElementsByClassName("select-container");
                    for (let x = 0; x < targetDiv[targetDiv.length - 1].getElementsByClassName("interaction-button").length; x++) {
                        targetDiv[targetDiv.length - 1].getElementsByClassName("interaction-button")[x].classList.remove("d-none");
                    }
                }
            }
        }
        // setState({ ...state, specialist: _specialists.data,loading: false })
    }
    useEffect(() => {


        const init = async () => {
            loadSpecialist()
        }
        init()

        return () => { }

    }, [])


    const onUpdatesSlots = async () => {
        console.log(state.slots);
    }

    function onDay(day) {
        //BUSCA EL CHECKBOX ACTIVADO
        if (document.getElementById(day).checked) {
            // MUESTRA EL VID QUE PERTENECE AL DIA
            document.getElementById(day + "_div").classList.remove("d-none");
            // AGREGA UN SLOT DE HORAS POR DEFECTO
            let findDay = _slots.filter(x => x.dayOfWeek == day);
            if (findDay.length === 0) {
                _slots.push(

                    {
                        "dayOfWeek": day,
                        "timeRanges": [
                            {
                                "startTime": "08:00:00",
                                "endTime": "17:00:00",
                            }
                        ]
                    }
                );
            }
             loadSpecialist();
        }
        else {
            // LIMPIA EL ARREGLO DE SLOTS
            _slots = _slots.filter(x => x.dayOfWeek !== day);
            let targetDiv = document.getElementById(day + "_div").getElementsByClassName("select-container");
            // ELIMINA ELEMENTOS HTML
            for (let i = 0; i <= targetDiv.length; i++) {
                targetDiv[0].remove();
            }
            document.getElementById(day + "_div").classList.add("d-none");
        }
    }

    function set_startTime(startTime,day) {
        let time = startTime.split(",")[0];
        let position = startTime.split(",")[1];
        let findDay = state.slots.filter(x => x.dayOfWeek == day);
        findDay[0].timeRanges[position - 1].startTime = time;
    }

    function set_endTime(endTime, day) {
        let time = endTime.split(",")[0];
        let position = endTime.split(",")[1];
        let findDay = state.slots.filter(x => x.dayOfWeek == day);
        findDay[0].timeRanges[position - 1].endTime = time;
    }

    return (
        <>
            <Renderif isTrue={state.loading === true}>
                <Loader></Loader>
            </Renderif>
            <div className='overlay d-flex justify-content-center align-items-center'>


                <div className='bv-modal overflow-auto hide-scroll shadow'>

                    <div className='d-flex  p-3'>

                        <div className='d-flex align-items-center'>
                            <div className='avatar avatar--big me-2'></div>

                        </div>
                        <div className='col'></div>
                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                            props.onClose()
                        }}>
                            <IoClose size={30} color={primary}></IoClose>
                        </div>


                    </div>

                    <div className='d-flex px-3'>

                        {/* <div className='col px-3'>

                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Nombre</div>
                                <div className='input--light'>
                                    <input placeholder='Nombre Apellido'></input>
                                </div>
                            </div>

                        </div> */}
                        <div class="col px-3">
                            <div className='mt-3'>
                                <label className='f-14 text-gray day-box-letter'><input type="checkbox" className='day-box' id="Monday" onClick={() => { onDay('Monday') }} />Lun</label>
                                <label className='f-14 text-gray day-box-letter'><input type="checkbox" className='day-box' id="Tuesday" onClick={() => { onDay('Tuesday') }} />Mar</label>
                                <label className='f-14 text-gray day-box-letter'><input type="checkbox" className='day-box' id="Wednesday" onClick={() => { onDay('Wednesday') }} />Mie</label>
                                <label className='f-14 text-gray day-box-letter'><input type="checkbox" className='day-box' id="Thursday" onClick={() => { onDay('Thursday') }} />Jue</label>
                                <label className='f-14 text-gray day-box-letter'><input type="checkbox" className='day-box' id="Friday" onClick={() => { onDay('Friday') }} />Vie</label>
                                <label className='f-14 text-gray day-box-letter'><input type="checkbox" className='day-box' id="Saturday" onClick={() => { onDay('Saturday') }} />Sab</label>
                                <label className='f-14 text-gray day-box-letter'><input type="checkbox" className='day-box' id="Sunday" onClick={() => { onDay('Sunday') }} />Dom</label>
                            </div>
                            <div className='mt-3'>
                                <div id="day-week-container" class="col px-3">
                                    <div class="day-week d-none" id="Monday_div">
                                        <label className='f-16 text-gray'>Lunes</label>
                                        {
                                            state.slots.filter(x => x.dayOfWeek === "Monday").map((item, i) => {
                                                console.log(item)
                                                let n = 0;
                                                return (
                                                    item.timeRanges.map((itemHour, Ih) => {
                                                        n = n + 1;
                                                        return (
                                                            <SelectBusinessOption
                                                                startTime={itemHour.startTime}
                                                                endTime={itemHour.endTime}
                                                                day={item.dayOfWeek}
                                                                n={n}
                                                                setStartTime={set_startTime}
                                                                setEndTime={set_endTime}
                                                            >
                                                            </SelectBusinessOption>
                                                        )

                                                    }

                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="day-week d-none"  id="Tuesday_div">
                                        <label>Martes</label>
                                        {
                                            state.slots.filter(x => x.dayOfWeek === "Tuesday").map((item, i) => {
                                                let n = 0;
                                                return (
                                                    item.timeRanges.map((itemHour, Ih) => {
                                                        n = n + 1;
                                                        return (
                                                            <SelectBusinessOption
                                                                startTime={itemHour.startTime}
                                                                endTime={itemHour.endTime}
                                                                day={item.dayOfWeek}
                                                                n={n}
                                                                setStartTime={set_startTime}
                                                                setEndTime={set_endTime}
                                                            >
                                                            </SelectBusinessOption>
                                                        )

                                                    }

                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                    <div class="day-week d-none" id="Wednesday_div">
                                        <label>Miércoles</label>
                                        {
                                            state.slots.filter(x => x.dayOfWeek === "Wednesday").map((item, i) => {
                                                let n = 0;
                                                return (
                                                    item.timeRanges.map((itemHour, Ih) => {
                                                        n = n + 1;
                                                        return (
                                                            <SelectBusinessOption
                                                                startTime={itemHour.startTime}
                                                                endTime={itemHour.endTime}
                                                                day={item.dayOfWeek}
                                                                n={n}
                                                                setStartTime={set_startTime}
                                                                setEndTime={set_endTime}
                                                            >
                                                            </SelectBusinessOption>
                                                        )

                                                    }

                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                    <div class="day-week d-none" id="Thursday_div">
                                        <label>Jueves</label>
                                        {
                                            state.slots.filter(x => x.dayOfWeek === "Thursday").map((item, i) => {
                                                let n = 0;
                                                return (
                                                    item.timeRanges.map((itemHour, Ih) => {
                                                        n = n + 1;
                                                        return (
                                                            <SelectBusinessOption
                                                                startTime={itemHour.startTime}
                                                                endTime={itemHour.endTime}
                                                                day={item.dayOfWeek}
                                                                n={n}
                                                                setStartTime={set_startTime}
                                                                setEndTime={set_endTime}
                                                            >
                                                            </SelectBusinessOption>
                                                        )

                                                    }

                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                    <div class="day-week d-none" id="Friday_div">
                                        <label>Viernes</label>
                                        {
                                            state.slots.filter(x => x.dayOfWeek === "Friday").map((item, i) => {
                                                let n = 0;
                                                return (
                                                    item.timeRanges.map((itemHour, Ih) => {
                                                        n = n + 1;
                                                        return (
                                                            <SelectBusinessOption
                                                                startTime={itemHour.startTime}
                                                                endTime={itemHour.endTime}
                                                                day={item.dayOfWeek}
                                                                n={n}
                                                                setStartTime={set_startTime}
                                                                setEndTime={set_endTime}
                                                            >
                                                            </SelectBusinessOption>
                                                        )

                                                    }

                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                    <div class="day-week d-none" id="Saturday_div">
                                        <label>Sabado</label>
                                        {
                                            state.slots.filter(x => x.dayOfWeek === "Saturday").map((item, i) => {
                                                let n = 0;
                                                return (
                                                    item.timeRanges.map((itemHour, Ih) => {
                                                        n = n + 1;
                                                        return (
                                                            <SelectBusinessOption
                                                                startTime={itemHour.startTime}
                                                                endTime={itemHour.endTime}
                                                                day={item.dayOfWeek}
                                                                n={n}
                                                                setStartTime={set_startTime}
                                                                setEndTime={set_endTime}
                                                            >
                                                            </SelectBusinessOption>
                                                        )

                                                    }

                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                    <div class="day-week d-none" id="Sunday_div">
                                        <label>Domingo</label>
                                        {
                                            state.slots.filter(x => x.dayOfWeek === "Sunday").map((item, i) => {
                                                let n = 0;
                                                return (
                                                    item.timeRanges.map((itemHour, Ih) => {
                                                        n = n + 1;
                                                        return (
                                                            <SelectBusinessOption
                                                                startTime={itemHour.startTime}
                                                                endTime={itemHour.endTime}
                                                                day={item.dayOfWeek}
                                                                n={n}
                                                                setStartTime={set_startTime}
                                                                setEndTime={set_endTime}
                                                            >
                                                            </SelectBusinessOption>
                                                        )

                                                    }

                                                    )
                                                )
                                            })
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                    <div className='d-flex b-top p-4'>

                        <div className='col'></div>

                        <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                            props.onClose()
                        }}>Cancelar</div>

                        <div className='bv-pill bv-pill--green cursor-pointer px-4' onClick={() => {
                            onUpdatesSlots()
                        }}>Guardar</div>
                    </div>

                    <div className=''></div>
                </div>


            </div>
        </>
        
    )
    
}
export function SelectBusinessOption({ startTime, endTime, day, n,setStartTime,setEndTime }) {
    function sendStarTime(startTime,day) {
        setStartTime(startTime,day);
      }
      function sendEndTime(endTime,day) {
        setEndTime(endTime,day);
      }
    return (
        <div class="select-container text-gray">
            <select onChange={(evt) => {
                sendStarTime(evt.currentTarget.value,day)
            }}>
                <option value={startTime + "," + n}>{startTime.substring(0, startTime.length - 3)}</option>
                <option value={"08:00:00" + "," + n}>08:00</option>
                <option value={"09:00:00" + "," + n}>09:00</option>
                <option value={"10:00:00" + "," + n}>10:00</option>
                <option value={"11:00:00" + "," + n}>11:00</option>
                <option value={"12:00:00" + "," + n}>12:00</option>
                <option value={"13:00:00" + "," + n}>13:00</option>
                <option value={"14:00:00" + "," + n}>14:00</option>
                <option value={"15:00:00" + "," + n}>15:00</option>
                <option value={"16:00:00" + "," + n}>16:00</option>
                <option value={"17:00:00" + "," + n}>17:00</option>
            </select>
            <label>a</label>
            <select onChange={(evt) => {
                sendEndTime(evt.currentTarget.value,day)
            }}>
                <option value={endTime + "," + n}>{endTime.substring(0, endTime.length - 3)}</option>
                <option value={"09:00:00" + "," + n}>09:00</option>
                <option value={"10:00:00" + "," + n}>10:00</option>
                <option value={"11:00:00" + "," + n}>11:00</option>
                <option value={"12:00:00" + "," + n}>12:00</option>
                <option value={"13:00:00" + "," + n}>13:00</option>
                <option value={"14:00:00" + "," + n}>14:00</option>
                <option value={"15:00:00" + "," + n}>15:00</option>
                <option value={"16:00:00" + "," + n}>16:00</option>
                <option value={"17:00:00" + "," + n}>17:00</option>
                <option value={"18:00:00" + "," + n}>18:00</option>
                <option value={"19:00:00" + "," + n}>19:00</option>
            </select>
            <MdAdd color={primary} className='interaction-button d-none' size={20}></MdAdd>
            <BiTrash color="red" className='interaction-button d-none' size={20}></BiTrash>
        </div>
    )
}